import { observable, action, computed } from 'mobx'
import Cookies from 'js-cookie'

const TOKEN_KEY = '__TOKEN__'
const LOGIN_USER_KEY = '__LOGIN_USER__'

class Store {
    @observable loading = false;

    // 控制服务弹窗显示隐藏，刷新/首次登录需要展示，展示过后不再每次进入页面展示
    @observable messageFlag = true

    // 系统异常时的错误信息，格式保持和后端接口返回的异常报文一致：{ message, ... }
    @observable.shallow error = null;

    @action setLoading(loading) {
        this.loading = loading
        return this
    }

    @action setMessageFlag(flag) {
        this.messageFlag = flag || !this.messageFlag
        return this
    }


    @action setError(error) {
        this.error = error
        return this
    }

    setLoginUser(user) {
        if (user) {
            Cookies.set(LOGIN_USER_KEY, JSON.stringify(user))
        } else {
            Cookies.remove(LOGIN_USER_KEY)
        }
        return this
    }

    @computed get loginUser() {
        const loginUser = Cookies.get(LOGIN_USER_KEY)
        return loginUser ? JSON.parse(loginUser) : {}
    }

    @computed get token() {
        return Cookies.get(TOKEN_KEY)
    }

    setToken(token) {
        if (token) {
            // token 默认2小时后失效（这里取小于2小时的值），在每次接口请求成功后，会刷新失效时间
            const expires = new Date()
            expires.setTime(expires.getTime() + 2 * 60 * 60 * 1000 - 10000)
            Cookies.set(TOKEN_KEY, token, { expires })
        } else {
            Cookies.remove(TOKEN_KEY)
        }
        return this
    }

    @action updateTokenExpires() {
        return this.setToken(this.token)
    }

    @computed get isAuthenticated() {
        return !!this.token
    }
}

export default new Store()
